export const SET_CURRENT_TENANT_BILLING_GROUP =
  "SET_CURRENT_TENANT_BILLING_GROUP";

export const GET_TENANT_MANAGEMENT_ACCOUNTS_LIST_REQUEST =
  "GET_TENANT_MANAGEMENT_ACCOUNTS_LIST_REQUEST";
export const GET_TENANT_MANAGEMENT_ACCOUNTS_LIST_SUCCESS =
  "GET_TENANT_MANAGEMENT_ACCOUNTS_LIST_SUCCESS";
export const GET_TENANT_MANAGEMENT_ACCOUNTS_LIST_FAILURE =
  "GET_TENANT_MANAGEMENT_ACCOUNTS_LIST_FAILURE";
